const packages = [
  {
    id: 1,
    name: "Essentials",
    currency: "AED",
    newPrice: 424,
    oldPrice: 499,
    annuallyBilled: 5090,
    description: "For businesses looking for VAT management",
    features: [
      "Accounting Software",
      "Mobile App (iOS & Android)",
      "VAT Management & Filling",
      "VAT Return Reporting",
      "VAT Registration",
    ],
  },
  {
    id: 2,
    name: "Standard",
    currency: "AED",
    newPrice: 849,
    oldPrice: 999,
    annuallyBilled: 10190,
    description:
      "For small businesses looking to manage their accounting and tax efficiently",
    features: [
      "Accounting Software",
      "Accounting and Bookkeeping",
      "Financial Statement",
      "Corporate TAX Management & Filing",
      "VAT Management & Filling",
    ],
  },
  {
    id: 3,
    name: "Growth",
    currency: "AED",
    newPrice: "1,274",
    oldPrice: "1,499",
    annuallyBilled: 15290,
    description:
      "For businesses looking for comprehensive financial management with dedicated support",
    features: [
      "Accounting Software",
      "Accounting and Bookkeeping",
      "Financial Statement",
      "Corporate TAX Management & Filing",
      "VAT Management & Filling",
      "Dedicated Account Manager",
      "Third-Party Integrations",
    ],
  },
];

export default packages;
